import React from 'react';
import { siteConfig } from '../data/config';
import AppHero from '../components/AppHero';
import AppFeatures from '../components/AppFeatures';
import AppContact from '../components/AppContact';

function FamilyBudget() {
  const app = siteConfig.apps.find(app => app.id === 'family-budget');

  return (
    <div className="family-budget-page">
      <AppHero
        title={app.title}
        subtitle="Smart Budgeting for Your Family"
        description="A comprehensive budgeting application designed to help families track expenses, set financial goals, and achieve better financial health. Available on iOS and Android devices."
        icon={app.icon}
        showStoreButtons={true}
        storeUrls={app.storeUrls}
        storeVisibility={app.storeVisibility}
      />

      <AppFeatures features={app.features} />

      <section className="app-screenshots">
        <div className="container">
          <h2 className="section-title">App Screenshots</h2>
          <div className="screenshots-grid">
            <div className="screenshot-item">
              <img 
                src="/images/family-budget/FamilyBudget0.png" 
                alt="Onboarding Screen" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Onboarding Screen</p>
            </div>
            <div className="screenshot-item">
              <img 
                src="/images/family-budget/FamilyBudget1.png" 
                alt="Water Track - Main Screen" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Main Screen</p>
            </div>
            <div className="screenshot-item">
              <img 
                src="/images/family-budget/FamilyBudget2.png" 
                alt="Add Expense Screen" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Add Expense Screen</p>
            </div>
            <div className="screenshot-item">
              <img 
                src="/images/family-budget/FamilyBudget3.png" 
                alt="Add Paycheck Screen" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Add Paycheck Screen</p>
            </div>
            <div className="screenshot-item">
              <img 
                src="/images/family-budget/FamilyBudget4.png" 
                alt="Monthly Summary Screen" 
                className="screenshot-image"
              />
              <p className="screenshot-caption">Monthly Summary Screen</p>
            </div>
          </div>
        </div>
      </section>

      <section className="app-purpose">
        <div className="container">
          <h2 className="section-title">Why Family Budgeting?</h2>
          <div className="purpose-content">
            <p>
              Managing family finances can be challenging, especially when multiple people are involved in spending decisions. 
              Family Budget was created to simplify this process by providing a clear, organized way to track expenses 
              and work toward financial goals together.
            </p>
            <p>
              The app helps develop healthy financial habits by providing insights into spending patterns, 
              setting realistic budgets, and tracking progress toward savings goals. Whether you're trying to save 
              for a major purchase, pay off debt, or simply gain better control over your finances, 
              Family Budget makes it easy to stay on track.
            </p>
            <div className="benefits-list">
              <h3>Benefits of Family Budgeting:</h3>
              <ul>
                <li>Better financial awareness and control</li>
                <li>Reduced financial stress and anxiety</li>
                <li>Improved communication about money matters</li>
                <li>Faster progress toward financial goals</li>
                <li>Emergency fund building</li>
                <li>Debt reduction and elimination</li>
                <li>Improved credit scores through better financial management</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="app-security">
        <div className="container">
          <h2 className="section-title">Security & Privacy</h2>
          <div className="security-content">
            <p>
              <strong>Your financial data is private and secure.</strong> Family Budget stores all your information 
              locally on your device, ensuring that your sensitive financial data never leaves your control.
            </p>
            <div className="security-features">
              <div className="security-feature">
                <i className="fas fa-lock"></i>
                <h3>Local Storage</h3>
                <p>All data is stored locally on your device, not in the cloud</p>
              </div>
              <div className="security-feature">
                <i className="fas fa-shield-alt"></i>
                <h3>No Data Sharing</h3>
                <p>We don't collect, share, or sell your financial information</p>
              </div>
              <div className="security-feature">
                <i className="fas fa-key"></i>
                <h3>Device Security</h3>
                <p>Leverages your device's built-in security features</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppContact appName={app.title} privacyLink={app.privacyLink} tosLink={app.tosLink} />
    </div>
  );
}

export default FamilyBudget;
